import { useLocation } from 'react-router-dom';
import { type MobilityApplicationEntrypointContextDataFragment } from '../../../../api/fragments';
import NotFoundResult from '../../../../components/results/NotFoundResult';
import { JourneyStage } from '../../FinderApplicationPublicAccessEntrypoint/types';
import JourneyBootStrap from './JourneyBootStrap';

export type GiftCodeJourneyLocationState = {
    token: string;
};

export type GiftCodeJourneyProps = {
    endpoint: MobilityApplicationEntrypointContextDataFragment;
};

const GiftCodeJourney = ({ endpoint }: GiftCodeJourneyProps) => {
    const state = useLocation().state as GiftCodeJourneyLocationState;
    const { token } = state || {};

    // also need to make sure that mobility has gift code
    if (!endpoint.mobilityApplicationModule.giftVoucherModuleId) {
        return <NotFoundResult />;
    }

    return <JourneyBootStrap endpoint={endpoint} initialStage={JourneyStage.ApplicantKYC} initialToken={token} />;
};

export default GiftCodeJourney;
